import React from 'react';
import { Alert } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useSelector } from 'react-redux';
import { formatDisplayDate } from '../helpers/displayDate';

const SubscriptionsDate = () => {
  const { t } = useTranslation();
  const shopData = useSelector(
    (state) => state.myShop?.myShop ?? {},
    shallowEqual,
  );
  const subscription = shopData?.subscription;

  const hasValidSubscription =
    subscription &&
    (subscription.expired_at != null || subscription.type != null);

  return (
    <div>
      {hasValidSubscription && (
        <Alert
          className='mb-2'
          message={
            <div>
              {t('your.current.subscription')}{' '}
              <span className='font-weight-bold'>{subscription?.type}</span>{' '}
              {t('will.expire.at')}{' '}
              {subscription?.expired_at ? (
                moment(new Date()).isBefore(subscription.expired_at) ? (
                  <span className='text-primary'>
                    {formatDisplayDate(subscription.expired_at)}
                  </span>
                ) : (
                  <span className='text-danger'>
                    {formatDisplayDate(subscription.expired_at)}
                  </span>
                )
              ) : null}
            </div>
          }
          type='info'
        />
      )}
    </div>
  );
};

export default SubscriptionsDate;
